import { client } from '../client';
import { Insurance, UserRoleName } from './types/UserProfile';

export const createPatientInsurance = async (payload: {
  user_id?: number;
  insurance: Insurance[];
}, userRole?: UserRoleName): Promise<Insurance[]> => {
  const basePath = userRole === UserRoleName.Collector ? '/collector/insurances' : '/insurances';
  const { data } = await client.post<Insurance[]>(basePath, payload);

  return data;
};
